import React from 'react';
import {
  DataBox,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from 'src/components/molecules/DataBox';
import { NewBarGraph } from 'src/components/molecules/graphs/NewBarGraph';
import { ValueTickFormatter } from 'src/utils/TickFormatters';
import { useMetrics } from '../../hooks/useMetrics';
import { useKpiMetricLabelMap } from '../../hooks/useKpiMetricLabelMap';

export const MetricsByChannelBarGraph: React.FC<DataBoxBaseProps> = ({
  ...props
}) => {
  const { data, isError, isLoading, dataKeys } = useMetrics('byChannel');
  const labelMap = useKpiMetricLabelMap();

  const legendProps: DataBoxLegendProps = {
    baseLegendKeys: dataKeys.data,
    placement: 'right',
    labelMap,
  };

  return (
    <DataBox
      {...props}
      legendProps={legendProps}
      hasData={data.length > 0}
      isError={isError}
      isLoading={isLoading}>
      <NewBarGraph
        data={data}
        xAxisKey={dataKeys.xAxis}
        tooltipLabelMap={labelMap}
        stacked={false}
        yAxisFormatter={ValueTickFormatter}
      />
    </DataBox>
  );
};
